// extracted by mini-css-extract-plugin
export var imageWrapper = "styles-module--image-wrapper--32KZ7";
export var title = "styles-module--title--2SwNE";
export var description = "styles-module--description--1aaEu";
export var link = "styles-module--link--sAEbu";